export const ModuleCompletionStatus = {
  LOCK : 0,
  COMPLETED : 1,
  IN_PROGRESS : 2,
}

export const COURSE_COMPLETION_STATUS = {
"feedBack": 0,
"retakeView": 0,
"retakeAttempt": 0
}